import { DATABASE_NAME } from ":shared/config/env-vars";
import { Database } from "./database";

export const database = new Database(DATABASE_NAME);
